import { Component, OnInit, OnChanges, SimpleChanges, DoCheck } from '@angular/core';
import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";
import { WidgetSelection } from "src/app/models/dashboard";


import * as Highcharts from "highcharts/highstock";
import theme from 'highcharts/themes/brand-dark';
import exporting from "highcharts/modules/exporting";
import offlineExporting from "highcharts/modules/offline-exporting";
theme(Highcharts);
exporting(Highcharts);
offlineExporting(Highcharts);


@Component({
  selector: "app-chart",
  templateUrl: "./chart-widget.component.html",
  styleUrls: ["./chart-widget.component.css"],
})
export class ChartWidgetComponent extends MultiSourceMultiValueWidget implements OnChanges, DoCheck {
  Highcharts = Highcharts;

  chart: Highcharts.Chart;
  //offset: number;
  stockConstructor = "stockChart";
  chartConstructor = "chart";
  chartCallback: Highcharts.ChartCallbackFunction;
  chartOptions?: Highcharts.Options;
  timeSelect: Boolean = true;
  dataDict: any;
  leftUnits: string;
  rightUnits: string;

  from: string;
  to: string;

  public rangeLimiter: any;

  private colours: string[];

  toggleFullscreen(){
    this.fullScreen = !this.fullScreen;
    const newHeight = this.fullScreen ? window.innerHeight - 350 : this.widget.height;
    this.chartOptions.chart.height = newHeight;
    // Only update the chart height — passing the full chartOptions would reset series names
    // and colours that were dynamically applied for Meta match configurations.
    this.chart?.update({ chart: { height: newHeight } });
  }

  liveDataOnly(): boolean {
    return false;//(<any>this.widget).period == null || (<any>this.widget).period == "";
  }

  override eventTypes: string[] = ["timeSeriesHover", "timeSeriesUnhover","timeSeriesSelect", "timeSeriesUnselect"];
  override timeSeriesEvent(type: string, uri: string): void {
    // find the series in the highchart chart and highlight it
    if (this.chart && this.chart.series) {
      const cseries = this.chart.series.find(se => (<any>se)?.userOptions?.uri === uri);
      if (cseries){
        if (type === 'timeSeriesHover') {
          cseries.setState('hover');
        } else if (type === 'timeSeriesUnhover') {
          cseries.setState('');
        }
        if (type === 'timeSeriesSelect') {
          let timeSeries = this.config.dynamicTimeSeriesList.find(ts => ts.uri == uri);
          if ((timeSeries as any).showWhenSelected) {
            // make series visible = true
            cseries.show();
          }
        } else if (type === 'timeSeriesUnselect') {
          let timeSeries = this.config.dynamicTimeSeriesList.find(ts => ts.uri == uri);
          if ((timeSeries as any).showWhenSelected) {
            // make series visible = true
            cseries.hide();
          }
        }
      }
    }
  }

  widgetAfterInit() {
    for (let i in this.config.dynamicTimeSeriesList) {
      const ts = <any>this.config.dynamicTimeSeriesList[i];
      let cseries = this.chart.series[i];
      if (ts.dynamic && ts.dynamic == true){
        cseries.update({ name: ts.dynamicDisplayName, color: this.colours[i] } as any, true);
      }else{
        cseries.update({ name: ts.dynamicDisplayName/*, color: this.colours[i]*/ } as any, true);
      }
    }
  }

  initComplete: boolean = false;
  widgetBeforeInit() {
    this.dataDict = {};

    // get the offset from UTC to Local in milliseconds
    //this.offset = -(new Date().getTimezoneOffset() * 60 * 1000);
    this.timeSelect = (<any>this.config).showTimeSelect;
    const series = [];
    const stacked = [];

    this.colours = [
      "#e6194b", "#3cb44b", "#ffe119", "#4363d8", "#f58231", "#911eb4", "#46f0f0", "#f032e6", "#bcf60c", "#fabebe",
      "#008080", "#e6beff", "#9a6324", "#fffac8", "#800000", "#aaffc3", "#808000", "#ffd8b1", "#000075", "#808080",
      "#ffffff", "#000000", "#ff6666", "#66ff66", "#6666ff", "#ffcc00", "#ccff00", "#00ccff", "#ff00cc", "#cc00ff",
      "#00ffcc", "#ff3300", "#33ff00", "#0033ff", "#ff0033", "#33ffff", "#ff33ff", "#ffff33", "#33ff33", "#ff6633",
      "#3366ff", "#ff3366", "#66ffcc", "#cc66ff", "#66ccff", "#ffcc66", "#66ff99", "#99ff66", "#ff9966", "#6699ff",
      "#9966ff", "#66cc99", "#99cc66", "#cc9966", "#6699cc", "#9966cc", "#cc6699", "#99cc99", "#cc99cc", "#99cccc",
      "#cccc99", "#cc9999", "#9999cc", "#9999ff", "#ff9999", "#99ff99", "#9999ff", "#ff99ff", "#99ffff", "#ffff99",
      "#ffcc99", "#ccff99", "#99ffcc", "#cc99ff", "#ff99cc", "#ccffcc", "#ffcccc", "#ccccff", "#ccffff", "#ffffcc",
      "#ffccff", "#ccff66", "#ff66cc", "#66ff66", "#ff66ff", "#66ffff", "#ffff66", "#ff9966", "#9966ff", "#66cc66",
      "#cc66cc", "#66ccff", "#ffcc33", "#33ccff", "#cc33ff", "#33ffcc", "#ff33cc", "#33cc33", "#cc33cc", "#33cc99"
    ];

    /*this.colours = [
      '#2f7ed8', '#8bbc21', '#910000', '#1aadce',
      '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a',
      "#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9",
      "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"
    ];*/

    let scatter = false

    for (let i in this.config.dynamicTimeSeriesList) {
      const ts = <any>this.config.dynamicTimeSeriesList[i];
      if (ts.colour == null){
        ts.colour = this.colours[i];
      }
      let markerState = false;
      if(ts.showMarker){
        markerState = ts.showMarker == null ? true : ts.showMarker;
      }

      let showWhenSelected = false;
      if(ts.showWhenSelected){
        showWhenSelected = ts.showWhenSelected == null ? false : ts.showWhenSelected;
      }

      //if the lineWidth is 0, marker will be shown
      if(ts.size==0){
        markerState = true;
      }

      let type = ts.type;
      let step = false;

      if (type.startsWith('stack')){
        type = type.substring(5);
        stacked.push(type);
      }
      if (type.startsWith('step')){
        type = type.substring(4);
        step = true;
      }

      //todo: how do we deal with this when there are multiple time series returned for one configuration?
      if (type != 'scatter')
      {
        series.push({
          uri: ts.uri,
          name: ts.displayName ?? "...",
          yAxis: ts.axis == null ? 0 : ts.axis,
          type: type == null ? "line" : type.toLowerCase(),
          dashStyle: ts.style == null ? "solid" : ts.style.toLowerCase(),
          color: ts.colour,
          lineWidth: ts.size,
          step: step,
          marker: {
            enabled: markerState,
          },
          visible: !showWhenSelected
        });


      }
      else
      {
          scatter = true;
          series.push({
            uri: ts.uri,
            name: ts.displayName ?? "...",
            yAxis: ts.axis == null ? 0 : ts.axis,
            type: type == null ? "line" : type.toLowerCase(),
            color: ts.colour,
            marker: {
              symbol: ts.markerType,
              radius: 1 + (ts.size * 2),
            },
            visible: !showWhenSelected
          });
      }

    }


    const c = <any>this.config;
    const currentTime = new Date();
    let minTime = new Date(c.from).getTime();
    let maxTime = new Date(c.to).getTime();
    if (c.period == null || c.period == ''){
      minTime = new Date(this.dashboard.from).getTime();
      maxTime = new Date(this.dashboard.to).getTime();
    }

    const tz = this.dashboard.timeZone ?? this.app.tenantTimeZone;

    this.leftUnits = (<any>this.widget).leftUnits;
    this.rightUnits = (<any>this.widget).rightUnits;



    // const match = text.match(/{(.+?)}/);
    // if (match) {
    //     const propertyPath = match[1];
    //     return propertyPath.split('.').reduce((acc, part) => acc && acc[part], this.dataDict);


    console.log("Setting TimeZone", tz);

    if (c.showCategories == null || c.showCategories == false){
      this.chartOptions = ({
        chart: {
          backgroundColor: "transparent",
          height: this.widgetComponent.fullScreen ? window.innerHeight - 300 : this.widget.height,
        },
        loading: {
          hideDuration: 1000,
          showDuration: 1000
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        time: {
          timezoneOffset: -this.app.getTimeZoneOffset(this.dashboard.timeZone)
        },
        legend: {
          enabled: (<any>this.widget).showLegend,
          borderWidth: 0,
          margin: 5
        },
        exporting: {
          enabled: true,
          fallbackToExportServer: false,
          filename: (this.widget.name),
          sourceWidth:1000,
          buttons: {
            contextButton: {
                theme:{
                  fill:"transparent",
                  stroke:"none"
                },
                //verticalAlign:'bottom',
                //symbol: 'circle',
                symbolFill: 'transparent'
            }
          },
          chartOptions:{
            navigator: {
              enabled:false
            },
            chart: {
              backgroundColor: 'white',
              styledMode: false
            },
            title: {
              style: { color: '#000000' }
            },
            legend: {
              itemStyle: { color: '#000000' }
            },
            xAxis: {
              labels: {
                style: {
                  color: '#000000',
                  fontSize: '12px'
                }
              },
              title: {
                style: { color: '#000000' }
              }
            },
            yAxis: [
              {
                labels: {
                  style: {
                    color: '#000000',
                    fontSize: '12px'
                  }
                },
                title: {
                  style: { color: '#000000' }
                }
              },
              {
                labels: {
                  style: {
                    color: '#000000',
                    fontSize: '12px'
                  }
                },
                title: {
                  style: { color: '#000000' }
                }
              }
            ]
          }
        },
        xAxis: {
          type: "datetime",
          title: { text: null },
          ordinal: false,
          plotLines: [
            {
              dashStyle: "longdash",
              width: 1,
              value: currentTime.getTime() + 2000,
              zIndex: 10000,
            },
          ] as any[],
        },
        yAxis: [
          {
            title: {
              text: this.leftUnits
            },
            startOnTick: false,
            endOnTick: false,
            lineWidth: 1,
            min:
              (<any>this.widget).leftMin === (<any>this.widget).leftMax
                ? null
                : (<any>this.widget).leftMin,
            max:
              (<any>this.widget).leftMin === (<any>this.widget).leftMax
                ? null
                : (<any>this.widget).leftMax,
            plotBands: this.getPlotBands(),
            plotLines: this.getPlotLines(),
          },
          {
            // Secondary yAxis
            title: {
              text: this.rightUnits,
            },

            opposite: true,
            startOnTick: true,
            endOnTick: true,
            min:
              (<any>this.widget).rightMin === (<any>this.widget).rightMax
                ? null
                : (<any>this.widget).rightMin,
            max:
              (<any>this.widget).rightMin === (<any>this.widget).rightMax
                ? null
                : (<any>this.widget).rightMax,
          },
        ],
        plotOptions: {
          series: {
            allowPointSelect: true,
            point:{
              events: {
                click: (event) => {
                  const uri = (event.target as any).series.userOptions.uri;
                  this.events.trigger('timeSeriesValueSelected', event, event);
                },
                mouseOver: (event) => {
                  const point = event.target as any;
                  const uri = point.series.userOptions.uri;
                  const timestamp = point.x;
                  const date = new Date(timestamp);
                  console.log('Point datetime:', date.toLocaleString(), 'Value:', point.y);
                  this.events.trigger('timeTrigger', event, date);
                  this.events.trigger('timeSeriesHover', uri, date);
                },
                mouseOut: (event) => {
                  const uri = (event.target as any).series.userOptions.uri;
                  this.events.trigger('timeSeriesUnhover', uri, event);
                },
                select: (event) => {
                  const uri = (event.target as any).series.userOptions.uri;
                  this.events.trigger('timeSeriesSelect', event, event);
                },
                unselect: (event) => {
                  const uri = (event.target as any).series.userOptions.uri;
                  this.events.trigger('timeSeriesUnselect', event, event);
                },

              }
            },
            events: {
              legendItemClick: (event) => {
                const uri = (event.target as any).options.uri;
                const visible = (event.target as any).visible;
                if (visible){
                  this.events.trigger('timeSeriesShown', uri, event);
                }else{
                  this.events.trigger('timeSeriesHidden', uri, event);
                }
              },
              mouseOver: (event) => {
                const uri = (event.target as any).options.uri;
                this.events.trigger('timeSeriesHover', uri, event);
              },
              mouseOut: (event) => {
                const uri = (event.target as any).options.uri;
                this.events.trigger('timeSeriesUnhover', uri, event);
              },
            }
          }
        },
        tooltip: {
          shared: true,
        },
        rangeSelector:{
          enabled: false
        },
        series: series,
        navigation: {
          buttonOptions: {
              verticalAlign: 'bottom',
              y: 0
          }
        }
      });

      if (scatter)
      {
        this.chartOptions.tooltip.headerFormat = '<span style="font-size:0.8em;">{point.x:%A, %e %b, %H:%M:%S.%L}</span>'
        this.chartOptions.tooltip.pointFormat = '<br/>' +
        '<b style="color:{series.color};font-size:1.2em;">&#8226</b> {series.name}: <b>{point.y}</b><br/>'
      }

      if ((<any>this.widget).stacked || stacked.length > 0){
        this.chartOptions.plotOptions.series = {
          stacking: 'normal'
        };
      }
    } else {
      this.chartOptions = ({
        chart: {
          backgroundColor: "transparent",
          height: this.widgetComponent.fullScreen ? window.innerHeight - 300 : this.widget.height,
        },
        loading: {
          hideDuration: 1000,
          showDuration: 1000
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: (<any>this.widget).showLegend,
          borderWidth: 0,
          margin: 5
        },
        exporting: {
          enabled: true,
          fallbackToExportServer: false,
          filename: (this.widget.name),
          sourceWidth:1000,
          buttons: {
            contextButton: {
                theme:{
                  fill:"transparent",
                  stroke:"none"
                },
                symbolFill: 'transparent'
            }
          },
          chartOptions:{
            navigator: {
              enabled:false
            },
            chart: {
              backgroundColor: 'white',
              styledMode: false
            },
            title: {
              style: { color: '#000000' }
            },
            legend: {
              itemStyle: { color: '#000000' }
            },
            xAxis: {
              labels: {
                style: {
                  color: '#000000',
                  fontSize: '12px'
                }
              },
              title: {
                style: { color: '#000000' }
              }
            },
            yAxis: [
              {
                title:{
                  text: (<any>this.widget).leftUnits,
                  style: { color: '#000000' }
                },
                labels: {
                  style: { color: '#000000', fontSize: '12px' }
                },
                startOnTick: false,
                endOnTick: false,
                lineWidth: 1,
                min: (<any>this.widget).leftMin === (<any>this.widget).leftMax ? null : (<any>this.widget).leftMin,
                max: (<any>this.widget).leftMin === (<any>this.widget).leftMax ? null : (<any>this.widget).leftMax,
                plotBands: this.getPlotBands(),
                plotLines: this.getPlotLines(),
              },
              {
                title:{
                  text: (<any>this.widget).rightUnits,
                  style: { color: '#000000' }
                },
                labels: {
                  style: { color: '#000000', fontSize: '12px' }
                },
                opposite: true,
                startOnTick: true,
                endOnTick: true,
                min:
                  (<any>this.widget).rightMin === (<any>this.widget).rightMax
                    ? null
                    : (<any>this.widget).rightMin,
                max:
                  (<any>this.widget).rightMin === (<any>this.widget).rightMax
                    ? null
                    : (<any>this.widget).rightMax,
              }
            ]
          }
        },
        xAxis: {
          crosshair: true
        },
        plotOptions: {
          series: {
            allowPointSelect: true,
          }
        },
        tooltip: {
          shared: true,
          pointFormat: 'The value for <b>{point.x}</b> is <b>{point.y}</b><br>' +
            '{point.custom.extraInformation}'
        },
        rangeSelector: {
          enabled: false
        },
        navigation: {
          buttonOptions: {
              verticalAlign: 'bottom',
              y: 0
          }
        }
      });
    }

    this.chartCallback = chart => {
      this.chart = chart;
      this.chart.showLoading();
    }

    this.initComplete = true;
  }

  refresh() {
    this.loadComplete(true);
  }

  widgetLiveDataLoaded(s: any) {
    const item = this.config.dynamicTimeSeriesList.find(d => d.uri == s.uri) as any;
    //console.log(item);
    if (item){
      const cseries = this.chart.series[item.index];
      if (cseries){
        const shift = false;
        cseries.addPoint([new Date(s.point.timeStamp).getTime(), s.point.value], true, shift);
      }
    }
    this.chart.hideLoading();
  }

  widgetDataLoaded(s: SharedSeries) {
    try {
      //console.log("widgetDataLoaded called");
      this.chartConstructor = "chart";
      this.chart?.hideLoading();
      if (s == null){
        return;
      }
      const c = <any>this.config;
      if (c.dynamicTimeSeriesList[s.index].dynamicDisplayName == null || c.dynamicTimeSeriesList[s.index].dynamicDisplayName == ''){
        c.dynamicTimeSeriesList[s.index].dynamicDisplayName = s.name;
      }

      this.dataDict[c.dynamicTimeSeriesList[s.index].displayName] = s.metaData;


      // todo: how can we tell the difference between different time series?
      if (this.chart && this.chart.series) {
        if (c.showCategories == null || c.showCategories == false){
          const item = <any>this.config.dynamicTimeSeriesList[s.index];
          item.uri = s.uri;
          item.index = s.index;

          if (item.customTooltip)
          {
            //we want to use custom tooltips
          }

          let type = item.type;
          let stacked = false;

          if (type.startsWith('stack')){
            type = type.substring(5);
            stacked = true;
          }

          // find chart series reference related to the data loaded
          //var cseries = this.chart.series.find(se => (<any>se)?.userOptions?.uri === s?.uri);
          let cseries = this.chart.series[s.index];

          if (cseries == null) {
            // if we have a dynamic index greater than 0, then we will have multiple traces to display.

            const ts = <any>this.config.dynamicTimeSeriesList[s.index];
            //if (ts.colour == null){

              ts.colour = Highcharts.getOptions().colors[1];//this.colours[s.dynamicIndex];
            //}
            //todo: how do we deal with this when there are multiple time series returned for one configuration?

            const newSeries = {
              uri: s.uri,
              name: s.name,
              yAxis: ts.axis == null ? 0 : ts.axis,
              type: type == null ? "line" : type.toLowerCase(),
              dashStyle: ts.style == null ? "solid" : ts.style.toLowerCase(),
              color: ts.colour,
              lineWidth: ts.size,
              marker: {
                enabled: ts.showMarker == null ? true : ts.showMarker,
              },
            };

            cseries = this.chart.addSeries(newSeries);
          }

          if (this.rangeLimiter == null){
            const data = [[new Date(s.from).getTime(),null], [new Date(s.to).getTime(),null]];
            this.rangeLimiter = this.chart.addSeries({
              name: "range limiter",
              data: data,
              color: 'white',
              lineWidth: 0,
              type: 'line',
              showInLegend: false
            });
          } else {
            const data = [[new Date(s.from).getTime(),null], [new Date(s.to).getTime(),null]];
            this.rangeLimiter.setData(data);
          }

          if (cseries) {
            if (item && item.dynamicDisplayName && item.dynamicDisplayName != ''){
              //cseries.name = item.dynamicDisplayName;
              if (item.dynamic && item.dynamic == true){
                cseries.update({ name: item.dynamicDisplayName, color: Highcharts.getOptions().colors[s.index] } as any, false);
              } else {
                cseries.update({ name: item.dynamicDisplayName, color: item.colour } as any, false);
              }

            }else{
              cseries.update({ name: s.name } as any, false);
            }


            if (s.from &&s.to) {
              this.from = s.from;
              this.to = s.to;
              this.chart.xAxis[0].setExtremes(new Date(s.from).getTime() , new Date(s.to).getTime() );
              //console.log("Setting extremes to " + this.from + " to " + this.to);
            }

            let max = -9999999;
            let min =  9999999;
            const data = [];
            if (s && s.values){

              let extraInformation = false;

              for (let v of s.values) {
                if (v.value){
                  max = Math.max(Number(v.value), max);
                  min = Math.min(Number(v.value), min);
                }
                const temp = {'x':new Date(v.timeStamp).getTime(),'y':Number(v.value)} //'custom':{'extraInformation':'test'}

                if ((<any>this.config).dynamicTimeSeriesList && (<any>this.config).dynamicTimeSeriesList.length >= s.index) //if theres a timeseries detail list and we can find our index in it
                {

                  if ((<any>this.config).dynamicTimeSeriesList[s.index].customTooltip) { //if we have a custom tooltip
                    extraInformation = true;
                    //push extra metadata into extrainformation
                    (<any>this.config).dynamicTimeSeriesList[s.index].customTooltipTags.forEach(tag => {
                      if(v.metaData[tag.metaTag])
                      {
                        //metatag exists
                        if(!(temp['custom']))
                        {
                          temp['custom'] = {'extraInformation':''}
                        }
                        //temp['custom']['extraInformation'] = 'test1<br>test2'

                        temp['custom']['extraInformation'] += tag.displayName + ': <b>' + v.metaData[tag.metaTag] + '</b><br>'
                      }
                    });
                  }
                }




                data.push(temp);

              }

              if(extraInformation)
              {
                this.chart.update({
                  tooltip: {
                      pointFormat: '<br/><b style="color:{series.color};font-size:1.2em;">&#8226</b> {series.name}: <b>{point.y}</b><br/>' +
                      '{point.custom.extraInformation}'
                  }
                });
              //Update scatter plot tooltips for custom tags
              if(cseries.type === 'scatter')
              {
                this.chartOptions.tooltip.pointFormat = '<br/>' +
                '<b style="color:{series.color};font-size:1.2em;">&#8226</b> {series.name}: <b>{point.y}</b><br/>' +
                '{point.custom.extraInformation}'
              }


              }

              //TODO: if we have this metadata we should set tooltip.valuesuffix to s.metaData.units
              //if(s.metaData && s.metaData.units){}
            }

            if (cseries.yAxis.max < max){
              //console.log('Updating max axis to ' + max);
              cseries.yAxis.update({max : max}, false);
              this.chartOptions.yAxis[0].max = max;
            }

            if (cseries.yAxis.min > min){
              //console.log('Updating min axis from ' + cseries.yAxis.min + ' to ' + min);
              cseries.yAxis.update({min : min}, false);
              this.chartOptions.yAxis[0].min = min;
            }

            let displayName = s.name;
            if (item && item.dynamicDisplayName && item.dynamicDisplayName != ''){
              displayName = item.dynamicDisplayName;
            }
            cseries.update({ name: displayName } as any, false);

            cseries.setData(data);
            //this.chart.legend.update({},true);
          }
        } else {

          //todo: load category based data
          const item = <any>this.config.dynamicTimeSeriesList[s.index];
          item.uri = s.uri;
          item.index = s.index;

          let displayName = s.name;
          if (item && item.dynamicDisplayName && item.dynamicDisplayName != ''){
            displayName = item.dynamicDisplayName;
          }

          let type = item.type;
          let stacked = false;

          if (type.startsWith('stack')){
            type = type.substring(5);
            stacked = true;
          }

          let cseries = this.chart.series[s.index];

          if (cseries == null) {
            const ts = <any>this.config.dynamicTimeSeriesList[s.index];
            if (ts.colour == null){
              ts.colour = this.colours[s.dynamicIndex];
            }
            const newSeries = {
              uri: s.uri,
              name: displayName,
              yAxis: ts.axis == null ? 0 : ts.axis,
              type: type == null ? "line" : type.toLowerCase(),
              dashStyle: ts.style == null ? "solid" : ts.style.toLowerCase(),
              color: ts.colour,
              lineWidth: ts.size,
              marker: {
                enabled: ts.showMarker == null ? true : ts.showMarker,
              },
            };

            cseries = this.chart.addSeries(newSeries);
          }

          if (cseries) {
            let max = -9999999;
            let min =  9999999;
            const data = [];
            const categories = [];
            if (s && s.values){
              for (let v of s.values) {
                if (v.value){
                  const j = JSON.parse(v.value);
                  for (let cat in j){
                    categories.push(cat);

                    max = Math.max(Number(j[cat].max), max);
                    min = Math.min(Number(j[cat].min), min);

                    //todo: choose parameter based on config
                    data.push([displayName, Number(j[cat][item.displayValue ?? "count"])]);
                  }
                }
              }
            }

            cseries.xAxis.setCategories(categories);
            cseries.setData(data);
          }
        }
      }

      this.chartOptions.yAxis[0].plotLines = this.getPlotLines();
      this.chartOptions.yAxis[0].plotBands = this.getPlotBands();
      if ((<any>this.widget).leftUnits && (<any>this.widget).leftUnits.match(/{(.+?)}/)) {
        const match = (<any>this.widget).leftUnits.match(/{(.+?)}/);
        if (match) {
          this.leftUnits = match[1].split('.').reduce((acc, part) => acc && acc[part], this.dataDict);
          this.chartOptions.yAxis[0].title.text = this.leftUnits;
        }
      }
      if ((<any>this.widget).rightUnits && (<any>this.widget).rightUnits.match(/{(.+?)}/)) {
        const match = (<any>this.widget).rightUnits.match(/{(.+?)}/);
        if (match) {
          this.rightUnits = match[1].split('.').reduce((acc, part) => acc && acc[part], this.dataDict);
          this.chartOptions.yAxis[1].title.text = this.rightUnits;
        }
      }

      // Update axis properties without affecting series colors
      // Using requestAnimationFrame to prevent UI blocking
      requestAnimationFrame(() => {
        this.chart?.yAxis[0]?.update({
          plotLines: this.chartOptions.yAxis[0].plotLines,
          plotBands: this.chartOptions.yAxis[0].plotBands,
          title: { text: this.chartOptions.yAxis[0].title.text }
        } as any, false);

        this.chart?.yAxis[1]?.update({
          title: { text: this.chartOptions.yAxis[1].title.text }
        } as any, false);
      });
    }
    catch (e) {
      console.error('Error in widgetDataLoaded:', e);
    }
  }

  override widgetDataLoadComplete(): void {
    // Use requestAnimationFrame for final chart update
    // Only redraw - don't call update(chartOptions) as it would reset series colors
    requestAnimationFrame(() => {
      //this.chart?.redraw();
      console.log("Data load complete, redrawing chart");
      this.chart?.legend.update({}, true);
    });
  }

  widgetDataAdded(s: SharedPoint) {
    const cseries = this.chart.series.find((se) => (<any>se).uri === s.uri);
    cseries.addPoint([new Date(s.timeStamp).getDate(), s.value]);
  }

  widgetDataLoadTimeout(){
    this.chart.hideLoading();
  }

  ngDoCheck() {
    for (let point in this.points) {
      //console.log(point);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // changes.prop contains the old and the new value...
    for (let propName in changes) {
      const chng = changes[propName];
      const cur = JSON.stringify(chng.currentValue);
      const prev = JSON.stringify(chng.previousValue);
    }
  }

  getPlotBands() {
    const bands = [];
    const c = <any>this.config;

    if (c.bandDetailList) {
      for (let b of c.bandDetailList) {
        let minValue = b.min;
        let maxValue = b.max;

        // Attempt to parse min and max if they are strings with curly brackets
        if (typeof minValue === 'string' && minValue.match(/{(.+?)}/)) {
          try {
            minValue = this.parseBandValue(minValue);
            minValue = parseFloat(minValue);
          } catch (error) {
            console.warn(`Failed to parse min value for ${b.name}: ${error.message}`);
            continue; // Skip this band if parsing fails
          }
        }

        if (typeof maxValue === 'string' && maxValue.match(/{(.+?)}/)) {
          try {
            maxValue = this.parseBandValue(maxValue);
            maxValue = parseFloat(maxValue);
          } catch (error) {
            console.warn(`Failed to parse max value for ${b.name}: ${error.message}`);
            continue; // Skip this band if parsing fails
          }
        }

        // Add band if min and max are numbers
        if (Highcharts.isNumber(minValue) && Highcharts.isNumber(maxValue)) {
          bands.push({
            color: b.colour,
            from: minValue,
            to: maxValue,
            label: {
              text: b.name,
              style: {
                color: '#FFF'
              }
            },
          });
        } else {
          console.warn(`Skipping band for ${b.name} due to invalid min or max values.`);
        }
      }
    }

    return bands;
  }

  getPlotLines() {
    const bands = [];
    const c = <any>this.config;
    if (c.lineDetailList) {
      for (let b of c.lineDetailList) {
        let lVal = b.value;
        if (typeof lVal === 'string' && lVal.match(/{(.+?)}/)) {
          try {
            lVal = this.parseBandValue(lVal);
            lVal = parseFloat(lVal);
            console.log("Plot line set to " + lVal);
          } catch (error) {
            console.warn(`Failed to parse value for ${b.name}: ${error.message}`);
            continue; // Skip this band if parsing fails
          }
        }

        bands.push({
          color: b.colour,
          value: lVal,
          width: 2,
          dashStyle: 'dash',
          label: {
            text: b.name,
            style: {
              color: '#FFF'
            }
          },
        });
      }
    }
    return bands;
  }

  private parseBandValue(text: string)
  {
    const match = text.match(/{(.+?)}/);
    if (match) {
        const propertyPath = match[1];
        return propertyPath.split('.').reduce((acc, part) => acc && acc[part], this.dataDict);
    } else {
        return null;
    }
  }

  drawTimeRegions(chart) {
    // use the current date range to determine if we should show weekends or day night or alternate hours
    //$.log(chart);
    const min = chart.xAxis[0].min;
    const max = chart.xAxis[0].max;
    const change = chart.xAxis[0].max - chart.xAxis[0].min;
    //$.log(change);
    // clear all plot bands
    if (chart.xAxis[0].plotLinesAndBands != null) {
      for (let p in chart.xAxis[0].plotLinesAndBands) {
        const band = chart.xAxis[0].plotLinesAndBands[p];
        if (band.id != null && band.id.indexOf("we") == 0) {
          chart.xAxis[0].removePlotBand(band.id);
        }
      }
    }

    // to start with, lets do just weekends
    const d = new Date(min);
    if (change > 14036748299) {
      // show months
      const from = new Date(d.getFullYear(), d.getMonth(), 1);
      const to = new Date(d.getFullYear(), d.getMonth() + 1, 1);
      do {
        chart.xAxis[0].addPlotBand({
          from: from.getTime(),
          to: to.getTime(),
          color: "rgba(244,244,244,0.4)",
          id: "we",
          zIndex: -2,
        });
        from.setMonth(from.getMonth() + 2);
        to.setMonth(to.getMonth() + 2);
      } while (to.getTime() < max);
    } else if (change > 410970196) {
      // show weekends
      d.setUTCDate(d.getUTCDate() - ((d.getUTCDay() + 1) % 7));
      d.setUTCSeconds(0);
      d.setUTCMinutes(0);
      d.setUTCHours(0);
      let i = d.getTime();
      do {
        chart.xAxis[0].addPlotBand({
          from: i,
          to: i + 2 * 24 * 60 * 60 * 1000,
          color: "rgba(244,244,244,0.4)",
          id: "we",
          zIndex: -2,
        });
        i += 7 * 24 * 60 * 60 * 1000;
      } while (i < max);
    }
  }
}
